// src/Components/Products/ProductGrid.js
import React, { useEffect, useState } from 'react';
import { getProducts, getAnimalTypes } from '../../services/api'; // Import API calls
import ProductCard from './ProductCard.js';
import { animalTypeLabel, isStorefrontSpeciesType } from '../../constants/speciesTypes';
import '../../styles/global.css';
import '../../styles/products.css';
import '../../styles/ProductGrid.css';
import { Dropdown, Form, Row, Col } from 'react-bootstrap';
import SkeletonCardGrid from '../common/SkeletonCardGrid';
import '../../styles/skeletons.css';

const ProductGrid = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [animalTypes, setAnimalTypes] = useState([]);
    const [filters, setFilters] = useState({
        speciesType: null,
        facility: null,
        isForSale: true
    });

    // Fetch animal types for the dropdown
    useEffect(() => {
        const fetchAnimalTypes = async () => {
            try {
                const types = await getAnimalTypes();
                // I-03 close 1c: a CUSTOMER filter offers only the storefront
                // categories — "Other reptile" has no shop page, so it is
                // never a filter here (the staff dropdowns still show it).
                setAnimalTypes((Array.isArray(types) ? types : []).filter(
                    (t) => isStorefrontSpeciesType(t.id)));
            } catch (error) {
            }
        };
        fetchAnimalTypes();
    }, []);

    // Fetch products based on filters
    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            try {
                const response = await getProducts(filters);
                setProducts(Array.isArray(response) ? response : []); // Ensure response is an array
            } catch (error) {
                setProducts([]); // Fallback to empty array on error
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, [filters]);

    return (
        <div className="product-grid-container">
            <h2 className="product-grid-title">Available Products</h2>
            <Form className="product-grid-filters">
                <Row>
                    <Col>
                        <Dropdown
                            onSelect={(val) => setFilters({ ...filters, speciesType: val })}
                            className="custom-dropdown"
                        >
                            <Dropdown.Toggle>Species Type</Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item eventKey="">All</Dropdown.Item>
                                {animalTypes.map((type) => (
                                    <Dropdown.Item key={type.id} eventKey={type.id}>
                                        {animalTypeLabel(type)}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                    <Col>
                        <Dropdown
                            onSelect={(val) => setFilters({ ...filters, facility: val })}
                            className="custom-dropdown"
                        >
                            <Dropdown.Toggle>Facility</Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item eventKey="">All</Dropdown.Item>
                                <Dropdown.Item eventKey="1">Facility 1</Dropdown.Item>
                                <Dropdown.Item eventKey="2">Facility 2</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                </Row>
            </Form>
            <div className="product-grid-results">
                {loading ? (
                    <SkeletonCardGrid count={8} />
                ) : (
                <Row>
                    {Array.isArray(products) && products.length > 0 ? (
                        products.map((product, productIdx) => (
                            <Col key={product.id} sm={6} md={4}>
                                {/* adv-review SF3 (2026-08-14): first-fold cards eager on EVERY
                                    category page, not just /frogs — the #99 never-loads
                                    symptom rides lazy-load on visible cards. */}
                                <ProductCard product={product} eagerImage={productIdx < 6} />
                            </Col>
                        ))
                    ) : (
                        <div className="product-grid-empty">
                            <h3 className="product-grid-empty-title">No products available</h3>
                            <p className="product-grid-empty-text">Check back soon for new arrivals or adjust your filters.</p>
                        </div>
                    )}
                </Row>
                )}
            </div>
        </div>
    );
};

export default ProductGrid;